'use client';
import * as React from 'react';
import { forwardRef, useMemo } from 'react';
import cn from 'clsx';
import SvgDone from './packages/granat-react/packages/toast/ext/@mts-ds/granat/src/components/toast/assets/done.svg.js';
import SvgInfo from './packages/granat-react/packages/toast/ext/@mts-ds/granat/src/components/toast/assets/info.svg.js';
import SvgWarning from './packages/granat-react/packages/toast/ext/@mts-ds/granat/src/components/toast/assets/warning.svg.js';
import SvgError from './packages/granat-react/packages/toast/ext/@mts-ds/granat/src/components/toast/assets/error.svg.js';
import styles from './toast.module.scss.js';

/**
 * Компонент Toast
 */
const Toast = /*#__PURE__*/forwardRef(({
  type = 'done',
  title,
  description,
  children,
  isMobileDevice
}, ref) => {
  const preparedAvatar = useMemo(() => {
    let avatar;
    if (children) {
      avatar = React.Children.only(children);
      if (avatar) {
        avatar = /*#__PURE__*/React.cloneElement(avatar, {
          size: 'm'
        });
      }
    }
    return avatar;
  }, [children]);
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles['mtsds-toast'], styles[`mtsds-toast--icon--${type}`], isMobileDevice ? styles['mtsds-toast--device-mobile'] : styles['mtsds-toast--device-desktop'])
  }, title && /*#__PURE__*/React.createElement("strong", {
    className: styles['mtsds-toast__title']
  }, title), /*#__PURE__*/React.createElement("p", {
    className: styles['mtsds-toast__description']
  }, description), preparedAvatar && /*#__PURE__*/React.createElement("div", {
    className: styles['mtsds-toast__avatar']
  }, preparedAvatar), !preparedAvatar && type && /*#__PURE__*/React.createElement("div", {
    className: styles['mtsds-toast__icon']
  }, type === 'done' && /*#__PURE__*/React.createElement(SvgDone, null) || type === 'warning' && /*#__PURE__*/React.createElement(SvgWarning, null) || type === 'info' && /*#__PURE__*/React.createElement(SvgInfo, null) || type === 'error' && /*#__PURE__*/React.createElement(SvgError, null)));
});
Toast.defaultProps = {
  isMobileDevice: false,
  children: undefined,
  title: undefined,
  type: 'done'
};

export { Toast as MtsDsToast, Toast };
